import { browserApi } from 'lib/httpClient';
import { MatrixParams, ServiceParams } from 'matrix';
import { SearchCategoryTypesResult } from 'searchCategoryTypes';

type SearchParams = Partial<MatrixParams & ServiceParams>;

async function searchCategoryType(query: SearchParams): Promise<SearchCategoryTypesResult> {
  const { token, ...params } = query;
  const { data } = await browserApi.get<SearchCategoryTypesResult>('/search/category-type', {
    params,
  });
  return data;
}

export default searchCategoryType;
